import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import camelCase from 'lodash/camelCase'
import { CaretBottomIcon } from '@slite/icons'
import Dropdown from './dropdown'
import { Button } from '..'

export class Select extends Component {
  static propTypes = {
    'data-test-id': PropTypes.string,
    optionId: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.any.isRequired,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
          .isRequired,
      })
    ).isRequired,
    popoverPlacement: PropTypes.string.isRequired,
  }

  static defaultProps = { popoverPlacement: 'bottom' }

  render() {
    const {
      optionId,
      options,
      onChange,
      placeholder = '',
      popoverPlacement,
      'data-test-id': dataTestId = 'select',
    } = this.props
    const currentOption = options.find((option) => option.id === optionId) || {}
    return (
      <Dropdown
        itemToString={(item) => (item ? item.title : '')}
        id={dataTestId}
        onSelect={onChange}
      >
        {({
          getRootProps,
          getButtonProps,
          getItemProps,
          highlightedIndex,
          isOpen,
        }) => {
          const props = getButtonProps()
          const buttonProps = Object.assign({}, props, {
            placeholder,
            type: 'button',
          })

          const isPlaceholder = !currentOption.title
          return (
            <Dropdown.Wrapper
              {...getRootProps({
                refKey: 'innerRef',
              })}
            >
              <Button
                variant="secondary"
                className="flexbox-grow padding-horizontal-24 margin-vertical-8"
                {...buttonProps}
                size="medium"
                style={{
                  height: '40px',
                  paddingTop: '0px',
                  paddingBottom: '0px',
                }}
                data-test-id={dataTestId}
              >
                <div
                  className={classNames(
                    'flexbox flexbox-grow flexbox-align-center flexbox-space-between',
                    isPlaceholder ? 'shade-30' : 'shade-10'
                  )}
                >
                  <div
                    className="flexbox flexbox-align-center"
                    style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}
                  >
                    {isPlaceholder ? (
                      placeholder
                    ) : (
                      <div>{currentOption.title}</div>
                    )}
                  </div>
                  <CaretBottomIcon />
                </div>
              </Button>

              {isOpen && (
                <Dropdown.Body placement={popoverPlacement}>
                  {options.map((option, index) => {
                    const itemProps = getItemProps({
                      item: option,
                      index,
                    })
                    return (
                      <Dropdown.Item
                        selected={highlightedIndex === index}
                        key={option.id}
                        className="padding-vertical-12"
                        style={{ lineHeight: 'inherit' }}
                        data-test-id={camelCase(itemProps.id)}
                        {...itemProps}
                        subtitle={option?.subtitle}
                      >
                        <div className="font-weight-medium flexbox flexbox-align-center">
                          {option.title}
                        </div>
                      </Dropdown.Item>
                    )
                  })}
                </Dropdown.Body>
              )}
            </Dropdown.Wrapper>
          )
        }}
      </Dropdown>
    )
  }
}
